import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import { withTUXIcon } from './withTUXIcon.js';
import * as React from 'react';

function IconTickCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor"
  }, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    className: props.className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 2A21.94 21.94 0 008.44 8.44 21.94 21.94 0 002 24c0 6.07 2.46 11.58 6.44 15.56A21.94 21.94 0 0024 46c6.07 0 11.58-2.46 15.56-6.44A21.94 21.94 0 0046 24c0-6.07-2.46-11.58-6.44-15.56A21.94 21.94 0 0024 2zm-12.73 9.27A17.94 17.94 0 0124 6c4.97 0 9.47 2.01 12.73 5.27A17.94 17.94 0 0142 24c0 4.97-2.01 9.47-5.27 12.73A17.94 17.94 0 0124 42c-4.97 0-9.47-2.01-12.73-5.27A17.94 17.94 0 016 24c0-4.97 2.01-9.47 5.27-12.73zm21.58 8.88c.2-.21.2-.55 0-.75l-2.22-2.25a.52.52 0 00-.74 0l-7.98 8.09-3.8-3.86a.52.52 0 00-.74 0l-2.22 2.25c-.2.2-.2.54 0 .74l6.4 6.48c.2.2.53.2.73 0l10.57-10.7z"
  }));
}
var TUXIconTickCircle = withTUXIcon(IconTickCircle);

export default IconTickCircle;
export { TUXIconTickCircle };
